import React from "react";
import "./components/About.css";

const AboutPage = () => {
  return (
    <section className="about-page">

      {/* HERO */}
      <div className="container about-hero">
        <h1>About Karma & Delta</h1>

        <p>
          Karma & Delta LLC is a UAE-based advisory company focused on artificial
          intelligence, innovation research, marketing consultancy, strategic advisory,
          and digital growth support.
        </p>

        <p>
          We were founded with a simple belief: modern businesses need more than
          fragmented consulting. They need integrated thinking across technology,
          market behavior, communications, and execution.
        </p>
      </div>

      {/* OUR PERSPECTIVE */}
      <div className="container about-section">

        <div className="about-left">
          <h2>Our Perspective</h2>
          <div className="yellow-line"></div>

          <p>
            We believe that the strongest business outcomes emerge when:
          </p>

          <ul>
            <li>Technology is connected to real use cases</li>
            <li>Strategy is grounded in evidence</li>
            <li>Marketing is informed by insight</li>
            <li>Execution is designed for scale</li>
          </ul>

          <p>
            That is why our work blends analytical thinking, commercial judgment,
            and implementation support.
          </p>
        </div>

        <div className="about-right mission-box">
          <h2>Our Mission</h2>
          <div className="yellow-line"></div>

          <p>
            To help clients make better strategic decisions and build future-ready
            capabilities through AI, research, marketing intelligence,
            and focused advisory support.
          </p>
        </div>

      </div>

      {/* WHAT WE VALUE */}
      <div className="container values-section">

        <h2>What We Value</h2>
        <div className="yellow-line center-line"></div>

        <div className="values-grid">

          <div className="value-card glass-card-bg">
            <h3>Clarity</h3>
            <div className="yellow-line"></div>
            <p>
              We simplify complexity and focus on what matters.
            </p>
          </div>

          <div className="value-card glass-card-bg">
            <h3>Practical Innovation</h3>
            <div className="yellow-line"></div>
            <p>
              We believe innovation should create usable, measurable value.
            </p>
          </div>

          <div className="value-card glass-card-bg">
            <h3>Strategic Integrity</h3>
            <div className="yellow-line"></div>
            <p>
              We approach every engagement with discretion, rigor,
              and long-term thinking.
            </p>
          </div>

          <div className="value-card glass-card-bg">
            <h3>Evidence-Based Decision-Making</h3>
            <div className="yellow-line"></div>
            <p>
              We value research, analysis, and structured judgment
              over noise and trends.
            </p>
          </div>

        </div>
      </div>

    </section>
  );
};

export default AboutPage;